export default "__VITE_ASSET__C_ziq4fc__"